export enum ActivationStatus {
  Active = 'active',
  Inactive = 'inactive',
  Acquire = 'acquire',
  Release = 'release',
}
